import { ComponentType } from "@angular/cdk/overlay";
import { inject, TemplateRef } from "@angular/core";
import { Injectable } from "@angular/core";
import { MatDialog, MatDialogConfig, MatDialogRef } from "@angular/material/dialog";
import { ViewportService } from "libs/tm-common/src/lib/services/viewport.lib.service";

@Injectable()
export class ResponsiveDialogAdapter extends MatDialog {
	private viewportService = inject(ViewportService);

	override open<T, D = any, R = any>(
		component: ComponentType<T> | TemplateRef<T>,
		config?: MatDialogConfig<D>
	): MatDialogRef<T, R> {
		return super.open(component, {
			...config,
			...this.viewportService.getMobileDialogSize(), //always use mobile dialog size on small viewports
		});
	}
}
